import { LEVEL_0_ROUTES } from './level0.states'
import { LEVEL_1_ROUTES } from './level1.states'

const levels = {
  0: LEVEL_0_ROUTES,
  1: LEVEL_1_ROUTES,
}

export function getRoutesByLevel(level: number) {
  const _level = level as keyof typeof levels
  return levels[_level] || {}
}
